module.exports = __webpack_public_path__ + "static/media/startup-icon-billing@3x.b112c994.png";